import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import AuthLoginSuppliers from 'views/pages/authentication/auth-forms/AuthLoginSuppliers';
// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/Login3')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/Register3')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/ForgotPassword3')));
const AuthForgotPassword2 = Loadable(lazy(() => import('views/pages/authentication/ResetPassword3')));
const TermsAndConditionsShow = Loadable(lazy(() => import('views/pages/TermsAndConditionsShow/termsAndConditions')));

const CodePage = Loadable(lazy(() => import('views/pages/authentication/CodeVerification3')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/loolu/admin',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/loolu/admin/login',
            element: <AuthLogin />
        },
        {
            path: '/loolu/admin/suppliers',
            element: <AuthLoginSuppliers />
        },
        {
            path: '/loolu/admin/register',
            element: <AuthRegister />
        },
        {
            path: '/loolu/admin/forgot',
            element: <AuthForgotPassword />
        },
        {
            path: '/loolu/admin/mfa',
            element: <CodePage />
        },
        {
            path: '/loolu/admin/reset-password',
            element: <AuthForgotPassword2 />
        },
        {
            path: '/loolu/admin/terms-and-conditions',
            element: <TermsAndConditionsShow />
        }
    ]
};

export default LoginRoutes;
